import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import Products from './pages/Products';
import Zones from './pages/Zones';
import Methods from './pages/Methods';
import Frequencies from './pages/Frequencies';
import Icons from './pages/Icons';
import SurfaceItems from './pages/SurfaceItems';
import Templates from './pages/Templates';
import Plans from './pages/Plans';
import PlanBuilder from './pages/PlanBuilder';
import PlanEditor from './pages/PlanEditor';
import ProductCreate from './pages/ProductCreate';
import Equipment from './pages/Equipment';
import Temperatures from './pages/Temperatures';
import Controls from './pages/Controls';
import ImportExcel from './pages/ImportExcel';
import UsersPage from './pages/Users';
import PlanAI from './pages/PlanAI';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <Clients />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            }
          />
          <Route
            path="/zones"
            element={
              <ProtectedRoute>
                <Zones />
              </ProtectedRoute>
            }
          />
          <Route
            path="/methods"
            element={
              <ProtectedRoute>
                <Methods />
              </ProtectedRoute>
            }
          />
          <Route
            path="/frequencies"
            element={
              <ProtectedRoute>
                <Frequencies />
              </ProtectedRoute>
            }
          />
          <Route
            path="/icons"
            element={
              <ProtectedRoute>
                <Icons />
              </ProtectedRoute>
            }
          />
          <Route
            path="/surface-items"
            element={
              <ProtectedRoute>
                <SurfaceItems />
              </ProtectedRoute>
            }
          />
          <Route
            path="/templates"
            element={
              <ProtectedRoute>
                <Templates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/plans"
            element={
              <ProtectedRoute>
                <Plans />
              </ProtectedRoute>
            }
          />
          <Route
            path="/plan-builder"
            element={
              <ProtectedRoute>
                <PlanBuilder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/plans/:planId/edit"
            element={
              <ProtectedRoute>
                <PlanEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products/new"
            element={
              <ProtectedRoute>
                <ProductCreate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/equipment"
            element={
              <ProtectedRoute>
                <Equipment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/temperatures"
            element={
              <ProtectedRoute>
                <Temperatures />
              </ProtectedRoute>
            }
          />
          <Route
            path="/controls"
            element={
              <ProtectedRoute>
                <Controls />
              </ProtectedRoute>
            }
          />
          <Route
            path="/import"
            element={
              <ProtectedRoute>
                <ImportExcel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <UsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/plan-ai"
            element={
              <ProtectedRoute>
                <PlanAI />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
